import UserProfileForm from "@components/form/profile/UserProfileForm";
import Breadcrumb from "@components/layout/Breadcrumb";
import Heading from "@components/layout/Heading";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const MyProfile: FunctionComponent = () => {
  const { t } = useTranslation();
  const breadcrumb = [
    {
      label: t("dashboard.dashboard"),
      href: "/zenith",
    },
    {
      label: t("profile.title"),
    },
  ];

  return (
    <section className="flex flex-col flex-1 space-y-4">
      <Breadcrumb items={breadcrumb} />
      <Heading>{t("profile.title")}</Heading>
      <UserProfileForm />
    </section>
  );
};

export default MyProfile;
